import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const getAllCardProducts = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.getAllCardProducts, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getAllDebitCardDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.debitCardDetails, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardRequestVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARD_VERIFY",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.debitCardRequestVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const debitCardRequestConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(
      API_CONFIG.debitCardRequestConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const RequestService = {
  getAllCardProducts,
  getAllDebitCardDetails,
  debitCardRequestVerify,
  debitCardRequestConfirm,
};

export default RequestService;
